<template>
    <date-inputs
        :id="fKey"
        :key="filter.value"
        :placeholder="filter.text"
        :val="filter.value"
        :name="fKey"
        :lock-past-days="filter.lockPastDays"
        :lock-future-days="filter.lockFutureDays"
        :lock-range-days-number="filter.lockRangeDaysNumber"
        @change="$emit('set-filter', $event)"
    />
</template>

<script>
import filterMixin from './filter.mixin'

export default {
    mixins: [filterMixin]
}
</script>